import { FuelType } from 'models/FuelType';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const FuelTypeActionType = {
    FETCH_FUELTYPES: 'FETCH_FUELTYPES',
    FETCH_FUELTYPES_SUCCESS: 'FETCH_FUELTYPES_SUCCESS',
    ADD_FUELTYPE: 'ADD_FUELTYPE',
    ADD_FUELTYPE_SUCCESS: 'ADD_FUELTYPE_SUCCESS',
    EDIT_FUELTYPE: 'EDIT_FUELTYPE',
    EDIT_FUELTYPE_SUCCESS: 'EDIT_FUELTYPE_SUCCESS',
    DELETE_FUELTYPE: 'DELETE_FUELTYPE',
    DELETE_FUELTYPE_SUCCESS: 'DELETE_FUELTYPE_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchFuelTypesAction {
    type: typeof FuelTypeActionType.FETCH_FUELTYPES
    payload: ApiPayload,
    returnPayload: FuelType[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddFuelTypesAction {
    type: typeof FuelTypeActionType.ADD_FUELTYPE
    payload: ApiPayload,
    returnPayload: FuelType,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteFuelTypesAction {
    type: typeof FuelTypeActionType.DELETE_FUELTYPE
    payload: ApiPayload,
    returnPayload: FuelType,
    meta: {
        isApiCall: boolean
    },
}

export type IFuelTypeActions = IFetchFuelTypesAction | IAddFuelTypesAction | IDeleteFuelTypesAction

const baseUrl = 'api/fueltypes';
export class FuelTypeActions {
    public static fetchFuelTypes(token: string): IFuelTypeActions {
        return {
            type: FuelTypeActionType.FETCH_FUELTYPES,
            payload: Api.fetchApiCall(baseUrl, token, FuelTypeActionType.FETCH_FUELTYPES_SUCCESS, FuelTypeActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addFuelType(token: string, fueltype: FuelType): IFuelTypeActions {
        return {
            type: FuelTypeActionType.ADD_FUELTYPE,
            payload: Api.postApiCall(baseUrl, token, FuelTypeActionType.ADD_FUELTYPE_SUCCESS, FuelTypeActionType.API_ERROR, fueltype),
            returnPayload: FuelType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editFuelType(token: string, fueltype: FuelType): IFuelTypeActions {
        return {
            type: FuelTypeActionType.EDIT_FUELTYPE,
            payload: Api.putApiCall(baseUrl + '/' + fueltype.id, token, FuelTypeActionType.EDIT_FUELTYPE_SUCCESS, FuelTypeActionType.API_ERROR, fueltype),
            returnPayload: FuelType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteFuelType(token: string, id: number): IFuelTypeActions {
        return {
            type: FuelTypeActionType.DELETE_FUELTYPE,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, FuelTypeActionType.DELETE_FUELTYPE_SUCCESS, FuelTypeActionType.API_ERROR, true),
            returnPayload: FuelType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
